import { createRoomConfig, editRoomConfig, fetchLanguagesAvailables, getAllServices } from "../../../../../../../api/repositoryEP";
import RoomConfigData, { RoomConfigCreateData, RoomConfigDataEdit, ServiceDto, TranslationData } from "../../../../../../../models/MappingData";
import { useEffect, useState } from "react";
import { Form, Row, Col, Button, Divider, Tabs, TabsProps } from "antd";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import './RoomForm.scss'
import { LoadingData } from "../../../../../../common";
import { MaterialSymbol, MaterialSymbolProps } from "react-material-symbols";
import 'react-material-symbols/rounded';
import IconSelectorMultiple from "../../../../../../IconsMaterialSymbol/IconSelectorMultiple";
import { useAppConfig } from "../../../../../../../Contexts/AppConfigContext";


interface RoomFormProps {
    drawerVisible: boolean;
    setDrawerVisible: (visible: boolean) => void;
    roomData: RoomConfigData | null;
    setRoomData: (roomData: RoomConfigData | null) => void;
    language: string;
    servicesAvailable: ServiceDto[];
}



const RoomForm = (props: RoomFormProps): JSX.Element => {
    const [roomNames, setRoomNames] = useState<Array<TranslationData>>([])
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loadingLanguages, setLoadingLanguages] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [codeValue, setCodeValue] = useState<string>(
        props.roomData?.code !== undefined ? props.roomData.code : ""
    );

 

    const [integrationCodeValue, setIntegrationCodeValue] = useState<string>(
        props.roomData?.integrationCode !== undefined ? props.roomData?.integrationCode : ""
    );
    const [selectedServiceIcons, setSelectedServiceIcons] = useState<MaterialSymbolProps["icon"][]>([]);
    const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);


    const appConfig = useAppConfig();

    useEffect(() => {
        setCodeValue(props.roomData?.code || "");
        setIntegrationCodeValue(props.roomData?.integrationCode || "");
        setSelectedServiceIds(props.roomData?.services?.map(s => s.id) || []);

    }, [props.roomData]);

    useEffect(() => {
        const icons = props.roomData?.services
            ?.filter(s => s.icon)
            .map(s => s.icon as MaterialSymbolProps["icon"]) || [];
        setSelectedServiceIcons(icons);

        const ids = props.roomData?.services?.map(s => s.id) || [];
        setSelectedServiceIds(ids);
    }, [props.roomData?.services]);


    useEffect(() => { }, [form])


    const optionsSelector = props.servicesAvailable
        .filter(s => s.icon)
        .map(s => {
            const normalizedLanguage = props.language.slice(0, 2).toLowerCase();
            const translatedName =
                s.name.find(n => n.language.slice(0, 2).toLowerCase() === normalizedLanguage)?.value ||
                s.name[0]?.value ||
                "No name available";

            return {
                label: (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <MaterialSymbol
                            icon={s.icon as MaterialSymbolProps["icon"]}
                            size={20}
                        />
                        <span>{translatedName}</span>
                    </div>
                ),
                value: s.id,  // ✅ el value es el ID
            };
        });



    useEffect(() => {
        if (props.drawerVisible) {
            if (props.roomData) {
                // Cargar valores en el form
                form.setFieldsValue({
                    integrationCode: props.roomData.integrationCode,
                    code: props.roomData.code,
                    internalNote: props.roomData.internNote,
                });
                setSelectedServiceIcons(props?.roomData?.services.filter(s => s.icon).map(s => s.icon as MaterialSymbolProps["icon"]));
                setRoomNames(props.roomData.name);
            } else {
                form.resetFields();
                setRoomNames([]); // o lo que necesites para crear
            }
        }
    }, [props.drawerVisible, props.roomData]);




    const closeDrawer = () => {
        props.setRoomData(null)
        form.resetFields();
        props.setDrawerVisible(false)
    }




    const modifyRoomName = (index: number, value: string) => {
        const newRoomNames = [...roomNames];
        newRoomNames[index].value = value;
        setRoomNames(newRoomNames);
    }


    const handleBtnCancel = () => {
        closeDrawer();
    }





    useEffect(() => {

        if (props.drawerVisible) {

            if (props.roomData) {

                setRoomNames(props.roomData.name);
            } else {
                setLoading(true);
                setLoadingLanguages(true)
                fetchLanguagesAvailables("wa").then((r) => {
                    if (r?.type === 1) {
                        const languages = r.data.map((lang: string) => {
                            return { language: lang, value: '' }
                        })
                        setRoomNames(languages)
                    } else {
                        props.setDrawerVisible(false)
                    }
                    setLoading(false);
                    setLoadingLanguages(false);
                })

            }
        }
    }, [props.drawerVisible]);




    const handleSave = () => {

        setLoading(true);

        if (props.roomData === null) { // CREATE
            const roomData: RoomConfigCreateData = {
                name: roomNames,
                code: codeValue,
                integrationCode: integrationCodeValue,
                internNote: form.getFieldValue("internalNote"),
                servicesSelected: selectedServiceIds
            }

            createRoomConfig(roomData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false);
            })

        } else { // EDIT
            const roomData: RoomConfigDataEdit = {
                id: props.roomData?.id,
                name: roomNames,
                code: codeValue ?? props.roomData.code,
                integrationCode: integrationCodeValue,
                internNote: form.getFieldValue("internalNote"),
                servicesSelected: selectedServiceIds
            }

            editRoomConfig(roomData).then((response) => {
                if (response?.type === 1) {
                    closeDrawer();
                }
                setLoading(false);
            })

        }

    }


    const handleChangeCode = (e: any) => {
        setCodeValue(e.target.value);
    };
    const handleChangeIntegrationCode = (e: any) => {
        setIntegrationCodeValue(e.target.value);
    };




    const mappingItems: TabsProps['items'] = [
        {
            key: '1',
            label: `${t("components.tab-mapping.title-pms")}`,
            children: <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.Item
                        name="code"
                        label={t("components.tab-mapping.room-config.drawer.code-in-pms")}
                        initialValue={props.roomData?.code}
                        rules={[
                            {
                                required: true,
                                message: t("components.tab-mapping.room-config.drawer.code-required") + ""
                            },
                        ]}

                    >
                        <Input className="app-input"
                            value={codeValue}
                            onChange={handleChangeCode}

                        />

                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.pms-codes-explanation")}
                    </small>
                </Col>
            </Row>,
        },
        {
            key: '2',
            label: `${t("components.tab-mapping.title-integrations")}`,
            children: <Row gutter={16}>

                <Col xs={24} md={24}>
                    <Form.Item
                        name="integrationCode"
                        label={t("components.tab-mapping.regimes-config.drawer.code-in-integrations")}
                        rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.code-required") ?? "Code is required" }]}
                        initialValue={props.roomData?.integrationCode}

                    >
                        <Input className="app-input"
                            value={integrationCodeValue}
                            onChange={handleChangeIntegrationCode}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.integration-codes-explanation")}
                    </small>
                </Col>
            </Row>,

        }
    ];


    return (
        <div className='room-form-component'>
            {loadingLanguages ? (
                <div className="loading-data" >
                    <LoadingData />
                </div>
            ) : (
                <Form form={form}
                    onFinish={handleSave}
                    layout="vertical"

                >
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label={t("components.tab-mapping.room-config.drawer.name")}
                                required
                                name="names" //  le damos un "nombre" simbólico al campo
                                validateStatus={roomNames.some(opt => !opt.value.trim()) ? "error" : ""}
                                help={
                                    roomNames.some(opt => !opt.value.trim())
                                        ? t("components.tab-mapping.room-config.drawer.name-required")
                                        : ""
                                }
                            >
                                {roomNames.map((item, optIndex) => (
                                    <div key={optIndex} className="room-input">
                                        <span>{item.language.toUpperCase().substring(item.language.length - 2)}</span>
                                        <Input
                                            value={item.value}
                                            onChange={(e) => modifyRoomName(optIndex, e.target.value)}
                                           className="input"
                                        />

                                    </div>
                                ))}
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="internalNote"
                                label={t("components.tab-mapping.room-config.drawer.internal-note")}
                            >
                                <Input className="app-input" />
                            </Form.Item>

                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="services"
                                label={t("components.tab-mapping.room-config.drawer.services")}
                            > {
                                    <IconSelectorMultiple
                                        onChange={(ids: any) => setSelectedServiceIds(ids)}
                                        value={selectedServiceIds}
                                        optionsSelector={optionsSelector}
                                        servicesAvailable={props.servicesAvailable}  
                                    />
                                }

                            </Form.Item>
                        </Col>



                        <Divider>
                            {t("components.tab-mapping.title-mapping-code")}
                        </Divider>
                        <Col xs={24} md={24}>
                            <Tabs defaultActiveKey="1" items={mappingItems} destroyInactiveTabPane={false} />
                        </Col>



                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button className="app-white-button width-95"  onClick={handleBtnCancel}>
                                    {t("components.button.cancel")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button
                                    className="app-button width-95"
                                    htmlType="submit"
                                    loading={loading}
                                    disabled={loading || codeValue?.length === 0 || integrationCodeValue?.length === 0 || roomNames.some(option => !option.value.trim())}  // <-- bloquea mientras valida
                                >
                                    {t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            )}
        </div>
    );
};

export default RoomForm